export default "__VITE_ASSET__D4Xl22VR__"